/** Shared rules for email/phone entry popups (register, login, register modal). */

export function emailDomainOk(value: string): boolean {
  const parts = value.split("@");
  if (parts.length < 2 || !parts[1]) return false;
  const domain = parts[1];
  if ((domain.match(/\.com/g) || []).length > 1) return false;
  const tld = domain.split(".");
  const last = tld.pop();
  return !!(last && /^[a-zA-Z]{2,}$/.test(last));
}

export function isValidContactEmail(value: string): boolean {
  const v = String(value).trim();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) && emailDomainOk(v);
}

export function isValidContactPhoneDigits(digits: string): boolean {
  return /^[6-9]\d{9}$/.test(digits);
}

export type SeedRegistrationOtpState = {
  email: string;
  phoneNumber: string;
  name?: string;
  method: "email" | "mobile";
};

/** Per-field messages for ContactEntryDialogs (name / email / phone). */
export type ContactEntryFieldErrors = Partial<Record<"name" | "email" | "phone", string>>;
